import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'management.ISP',
  path: '/management/isp',
  title: 'View TPIAs',
  component: dynamicWrapper(app,[import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);